import {Route, Routes} from "react-router-dom";
import Login from "./login/login";
import ProtectedRoute, {RootRedirect} from "../config/protected-route";
import Dashboard from "./dashboard/dashboard";
import Profile from "./dashboard/profile/profile";
import OperatorDashboardHome from "./dashboard/operator-home/operator-dashboard-home";
import ChatPage from "./dashboard/chat/chat";
import ChatHistory from "./dashboard/chat-history/chat-history";
import AdminDashboardHome from "./dashboard/admin-home/admin-dashboard-home";
import Operators from "./dashboard/operators/operators";
import OperatorStatusManager from "./dashboard/operator-status/operator-status-manager";
import Notification from "./dashboard/notification/notification";
import WidgetSettings from "./dashboard/widget-settings/widget-settings";
import AuditLog from "./dashboard/audit-log/audit-log";
import DeletedItems from "./dashboard/deleted-items/deleted-items";
import FeatureFlags from "./dashboard/feature-flags/feature-flags";
import SystemHealth from "./dashboard/system-health/system-health";
import ShiftsPage from "./dashboard/shifts/shifts";

// مسیرهایی که بک‌اندشان ADMIN_ACCESS است، این‌جا هم به نقش ADMIN محدود می‌شوند تا
// اپراتور با تایپ دستی آدرس، صفحه‌ای را ببیند که هر درخواستش ۴۰۳ می‌گیرد.
const ADMIN_ONLY = ["ADMIN"];

// The live desk and the archive are shared by everyone who works conversations. The supervisor is
// on this list and on no other: every ADMIN_ONLY route below stays closed to them, which mirrors the
// backend, where they hold DESK_ACCESS but never ADMIN_ACCESS.
const DESK_ROLES = ["ADMIN", "OPERATOR", "SUPERVISOR"];

// The shift rota. Its own array rather than an entry added to ADMIN_ONLY — that constant feeds eight
// wrappers including widget settings, deleted items and the audit log, so widening it to admit a
// supervisor here would admit them to all eight. Mirrors SHIFT_ADMIN_ACCESS on the backend, which is
// itself a new constant for the same reason.
const SHIFT_ROLES = ["ADMIN", "SUPERVISOR"];

const ModuleRoutes = () => {
    return (
        <Routes>
            <Route
                path="/"
                element={
                    <RootRedirect/>
                }
            />
            <Route
                path="/login"
                element={
                    <Login/>
                }
            />
            <Route
                path="/dashboard/*"
                element={
                    <ProtectedRoute>
                        <Dashboard/>
                    </ProtectedRoute>
                }
            >
                <Route path="operator-home" element={<OperatorDashboardHome/>}/>
                <Route
                    path="admin-home"
                    element={
                        <ProtectedRoute roles={ADMIN_ONLY}>
                            <AdminDashboardHome/>
                        </ProtectedRoute>
                    }
                />

                <Route
                    path="operators"
                    element={
                        <ProtectedRoute roles={ADMIN_ONLY}>
                            <Operators/>
                        </ProtectedRoute>
                    }
                />
                <Route
                    path="operators/status"
                    element={
                        <ProtectedRoute roles={ADMIN_ONLY}>
                            <OperatorStatusManager/>
                        </ProtectedRoute>
                    }
                />

                <Route path="shifts" element={<ProtectedRoute roles={SHIFT_ROLES}><ShiftsPage/></ProtectedRoute>}/>
                <Route path="chats" element={<ProtectedRoute roles={DESK_ROLES}><ChatPage/></ProtectedRoute>}/>
                <Route path="chats/:chatId" element={<ProtectedRoute roles={DESK_ROLES}><ChatPage/></ProtectedRoute>}/>
                <Route path="history/chats" element={<ProtectedRoute roles={DESK_ROLES}><ChatHistory/></ProtectedRoute>}/>

                <Route path="notifications" element={<Notification/>}/>

                <Route path="settings/profile" element={<Profile/>}/>
                <Route
                    path="settings/widget"
                    element={
                        <ProtectedRoute roles={ADMIN_ONLY}>
                            <WidgetSettings/>
                        </ProtectedRoute>
                    }
                />
                <Route
                    path="system-health"
                    element={
                        <ProtectedRoute roles={ADMIN_ONLY}>
                            <SystemHealth/>
                        </ProtectedRoute>
                    }
                />
                <Route
                    path="feature-flags"
                    element={
                        <ProtectedRoute roles={ADMIN_ONLY}>
                            <FeatureFlags/>
                        </ProtectedRoute>
                    }
                />
                <Route
                    path="deleted-items"
                    element={
                        <ProtectedRoute roles={ADMIN_ONLY}>
                            <DeletedItems/>
                        </ProtectedRoute>
                    }
                />
                <Route
                    path="audit-log"
                    element={
                        <ProtectedRoute roles={ADMIN_ONLY}>
                            <AuditLog/>
                        </ProtectedRoute>
                    }
                />
            </Route>
        </Routes>
    )
}

export default ModuleRoutes;
